import React from "react";
import { FaArrowRight, FaBolt, FaRedoAlt } from "react-icons/fa";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    if (process.env.NODE_ENV !== "production") return;

    this.handleGlobalError = (event) => {
      const isOpaqueCrossOriginError =
        event?.type === "error" &&
        event?.message === "Script error." &&
        !event?.filename &&
        event?.lineno === 0 &&
        event?.colno === 0;

      if (isOpaqueCrossOriginError) {
        return;
      }

      event.preventDefault?.();
      this.setState({ hasError: true });
    };

    window.addEventListener("error", this.handleGlobalError);
    window.addEventListener("unhandledrejection", this.handleGlobalError);
  }

  componentWillUnmount() {
    if (!this.handleGlobalError) return;

    window.removeEventListener("error", this.handleGlobalError);
    window.removeEventListener("unhandledrejection", this.handleGlobalError);
  }

  componentDidCatch(error, errorInfo) {
    // Keep development diagnostics available while replacing the production
    // crash screen with the CarrerUp recovery experience.
    if (process.env.NODE_ENV !== "production") {
      console.error("React Error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-error-boundary" role="alert">
          <div className="app-error-orbit app-error-orbit-one" />
          <div className="app-error-orbit app-error-orbit-two" />
          <section className="app-error-card">
            <div className="app-error-icon"><FaBolt /></div>
            <span className="app-error-kicker">CARRERUP / SYSTÈME</span>
            <h1>Une interruption est survenue.</h1>
            <p>Votre session est protégée. Relancez l’espace CarrerUp pour continuer.</p>
            <div className="app-error-actions">
              <button type="button" className="app-error-retry" onClick={() => window.location.reload()}><FaRedoAlt /> Réessayer</button>
              <button type="button" className="app-error-home" onClick={() => window.location.assign("/")}>Accueil <FaArrowRight /></button>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
